// extracted by mini-css-extract-plugin
export default {"container":"Preloader_container__qVo0P","content":"Preloader_content__IfNxT","center":"Preloader_center__rx3LV","over":"Preloader_over__Pmia-","disabled":"Preloader_disabled__9zgt1"};